export default "__VITE_ASSET__Bin1$xge__"